import { useLocation } from '@reach/router'

// eslint-disable-next-line import/prefer-default-export
export function isPrint() {
  const { search } = useLocation()
  if (typeof window === 'undefined') return false
  const searchParams = new URLSearchParams(search)
  const isPrintMediaQuery = window.matchMedia('print').matches
  return searchParams.has('print') || isPrintMediaQuery
}
